// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2c1Hg","amount":"Amount_amount__2Lbae","tip":"Amount_tip__2B-Wo","tipHeader":"Amount_tipHeader__206Ub","tipsWrap":"Amount_tipsWrap__3SWwV"};